import React, { useState } from 'react';
import "./PointsTab.css";
// import "./../LoyalitySchemeAccordion.css";

const PointsTab = ({
  restaurants,
  isRestaurantsLoading,
  handleRestaurantClick,
  handleRewardsClick,
  gift
}) => {
  const [search, setSearch] = useState(''); 
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const filteredRestaurants = restaurants?.filter((restaurant) =>
    restaurant.restaurantName.toLowerCase().includes(search.toLowerCase())
  ) || [];

  const totalPages = Math.ceil(filteredRestaurants.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentRestaurants = filteredRestaurants.slice(startIndex, startIndex + itemsPerPage);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div className="points-section">
      <div className="section-header">
        <h2 className="loyalty-title">Points by Restaurant</h2>
        <input
          type="text"
          placeholder="Search restaurants..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="loyalty-search-input"
        />
      </div>
      <div className="restaurant-table">
        <div className="table-header">
          <span className="th-restaurant">Restaurant</span>
          <span className="th-earned">Earned</span>
          <span className="th-redeemed">Redeemed</span>
          <span className="th-available">Available</span>
        </div>
        <div className="table-body">
          {isRestaurantsLoading ? (
            <div className="loader">Loading restaurants...</div>
          ) : currentRestaurants.length > 0 ? (
            currentRestaurants.map((restaurant, index) => (
              <div
                className="restaurant-row clickable"
                key={index}
                onClick={() => handleRestaurantClick(restaurant)}
              >
                <div className="loylaty-restaurant-info">
                  <div className="restaurant-icon">
                    {restaurant?.logoUrl ? (
                      <img
                        src={restaurant.logoUrl}
                        alt={restaurant.name || "Restaurant logo"}
                        className="loylaty-restaurant-logo"
                      />
                    ) : (
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                        <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                      </svg>
                    )}
                  </div>
                  <span className="restaurant-name">
                    {restaurant.restaurantName}
                  </span>
                  <button
                    className="rewards-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRewardsClick(restaurant);
                    }}
                    title="View Rewards"
                  >
                    <img src={gift} alt="Gift" width="30" height="30" />
                  </button>{" "}
                </div>
                <div className="points-cell earned">
                  <span className="points-value">
                    +{restaurant.totalEarnedPoints}
                  </span>
                </div>
                <div className="points-cell redeemed">
                  <span className="points-value">
                    -{restaurant.totalRedeemedPoints}
                  </span>
                </div>
                <div className="points-cell available">
                  <span className="points-value">
                    {restaurant.totalEarnedPoints - restaurant.totalRedeemedPoints}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div className="no-data">
              {search ? "No restaurants found matching your search." : "No loyalty points found."}
            </div>
          )}
        </div>
      </div>
      {!isRestaurantsLoading && filteredRestaurants.length > 0 && (
        <div className="pagination">
          <button onClick={handlePrev} disabled={currentPage === 1} className="pagination-btn">
            Previous
          </button>
          <span className="page-info">
            Page {currentPage} of {totalPages}
          </span>
          <button onClick={handleNext} disabled={currentPage === totalPages} className="pagination-btn">
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default PointsTab;